interface IconProps {
  className?: string;
}

const PATHS = {
  check: 'M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z',
  close:
    'M18.3 5.71 12 12l6.3 6.29-1.41 1.42L10.59 13.41 4.29 19.71 2.88 18.3 9.17 12 2.88 5.7 4.29 4.29 10.59 10.59 16.89 4.29z',
  keyboardArrowDown: 'M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z',
  launch:
    'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z',
  helpOutline:
    'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z',
  filterList: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z',
  sort: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm3 7h12v-2H3v2z',
  chevronLeft: 'M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z',
  chevronRight: 'M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z',
  shield: 'M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5z',
} as const;

function Icon({ path, className }: IconProps & { path: string }) {
  return (
    <svg
      aria-hidden="true"
      className={`size-6 fill-current ${className ?? ''}`}
      viewBox="0 0 24 24"
    >
      <path d={path} />
    </svg>
  );
}

export function KeyboardArrowDownIcon(props: IconProps) {
  return <Icon path={PATHS.keyboardArrowDown} {...props} />;
}

export function CheckIcon(props: IconProps) {
  return <Icon path={PATHS.check} {...props} />;
}

export function CloseIcon(props: IconProps) {
  return <Icon path={PATHS.close} {...props} />;
}

export function LaunchIcon(props: IconProps) {
  return <Icon path={PATHS.launch} {...props} />;
}

export function HelpOutlineIcon(props: IconProps) {
  return <Icon path={PATHS.helpOutline} {...props} />;
}

export function FilterListIcon(props: IconProps) {
  return <Icon path={PATHS.filterList} {...props} />;
}

export function SortIcon(props: IconProps) {
  return <Icon path={PATHS.sort} {...props} />;
}

export function ChevronLeftIcon(props: IconProps) {
  return <Icon path={PATHS.chevronLeft} {...props} />;
}

export function ChevronRightIcon(props: IconProps) {
  return <Icon path={PATHS.chevronRight} {...props} />;
}

export function ShieldIcon(props: IconProps) {
  return <Icon path={PATHS.shield} {...props} />;
}
